import React, { FunctionComponent, useCallback, FormEventHandler } from 'react';
import { withBufferedValue } from '../../decorators/withBufferedValue/withBufferedValue';
import { prepareProps } from '../../utils/propUtils';
import { InputLayout, InputLayoutProps } from '../InputLayout/InputLayout';
import sharedStyles from '../sharedStyles.module.css';

export enum TextInputType {
  Text = 'text',
  Password = 'password',
  Email = 'email'
}

export type TextInputProps = Omit<
  InputLayoutProps,
  'children' | 'onInput' | 'onChange' | 'onInputCapture' | 'onChangeCapture'
> & {
  value: string;
  type?: TextInputType;
  onInput: (value: string) => void;
};

export const TextInput: FunctionComponent<TextInputProps> = React.memo(
  (props) => {
    const {
      value,
      type = TextInputType.Text,
      onInput,
      ...remainingProps
    } = prepareProps({ props, ignoreChildren: true });

    const handleInput: FormEventHandler<HTMLInputElement> = useCallback(
      (event) => {
        onInput(event.currentTarget.value);
      },
      [onInput]
    );

    return (
      <InputLayout {...remainingProps}>
        {() => (
          <input
            type={type}
            className={sharedStyles.inputBaseStyle}
            value={value}
            onInput={handleInput}
            data-testid="TextInput.input"
          ></input>
        )}
      </InputLayout>
    );
  }
);

export const BufferedTextInput = withBufferedValue(TextInput);
